// extracted by mini-css-extract-plugin
export default {"alertIcon":"ModalGoOffline_alertIcon__ve4DC"};